module.exports = __webpack_public_path__ + "img/logo_text_cn.20517e5e.png";